<template>
  <div v-if="showAddWorker" class="project-provider-table-cell">
    <v-btn large class="add-new-worker-button" @click="addWorker">{{ $t('project.add.new.worker') }}</v-btn>
    <select-service-provider-popup
      v-if="showWorkers"
      :visiblePopup="showWorkers"
      :project="item"
      @onEscapeClicked="closeWorkersPopup"
      @onSaveClicked="updateServiceProvider"
    />
    <message-popup
      :visible-popup="showError"
      :title="'error.popup.title'"
      :message="'error.something.wrong.message'"
      :okCaption="$t('confirm.ok')"
      @clicked="onClickErrorMessageButton"
    />
  </div>
  <div v-else-if="allowedToShow" class="project-provider-table-cell">
    <div v-if="!isTestCard">
      <v-avatar>
        <img v-if="worker.avatarURL" class="avatar" :src="worker.avatarURL" />
        <v-icon v-else class="initials">{{ initials }}</v-icon>
      </v-avatar>
      <div class="name">{{ worker.firstName }} {{ worker.lastName }}</div>
    </div>
    <div v-else class="project-provider-table-cell">
      <v-avatar>
        <img v-if="worker.logo" class="avatar" :src="worker.logo" />
        <logo-no-text v-else />
      </v-avatar>
      <div class="name">{{ worker.type }}</div>
    </div>
  </div>
</template>

<script>
import { projectStatuses, automaticTestProjectType } from '@/constants/projects';
import { CLEAR_WORKERS, LOAD_WORKERS } from '@/store/user/actionTypes';
import { UPDATE_SERVICE_PROVIDER } from '@/store/project/actionTypes';

import MessagePopup from '@/components/popup/MessagePopup.vue';
import SelectServiceProviderPopup from '@/components/popup/SelectServiceProviderPopup.vue';
import LogoNoText from '@/assets/logo-no-text.svg?inline';

export default {
  name: 'ProjectProviderTableCell',
  components: { SelectServiceProviderPopup, MessagePopup, LogoNoText },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    showWorkers: false,
    showError: false,
  }),
  computed: {
    isTestCard() {
      return this.item.type === automaticTestProjectType;
    },
    worker() {
      if (this.item.serviceProviderWorker !== undefined) {
        return true;
      }
      return false;
    },
    initials() {
      if (!this.isTestCard && this.item.serviceProviderWorker) {
        const firstChar = this.item.serviceProviderWorker.firstName[0].toUpperCase();
        const secondChar = this.item.serviceProviderWorker.lastName[0].toUpperCase();

        return `${firstChar}${secondChar}`;
      }
      return null;
    },
    showAddWorker() {
      return this.item.status === projectStatuses.DECLINED;
    },
    allowedToShow() {
      return (!!this.worker || !!this.isTestCard);
    },
  },
  methods: {
    addWorker() {
      this.showWorkers = !this.showWorkers;
      const { startDate, endDate } = this.item;
      this.$store.dispatch(LOAD_WORKERS, { startDate, endDate });
    },
    closeWorkersPopup() {
      this.showWorkers = !this.showWorkers;
      this.$store.dispatch(CLEAR_WORKERS);
    },
    onClickErrorMessageButton() {
      this.showError = false;
    },
    async updateServiceProvider(projectProviderData) {
      try {
        await this.$store.dispatch(UPDATE_SERVICE_PROVIDER, {
          id: this.item.id,
          data: {
            serviceProviderWorkerId: projectProviderData.serviceProviderId,
            budget: projectProviderData.projectTotalPrice,
            startDate: projectProviderData.startDate,
            endDate: projectProviderData.endDate,
          },
        });
      } catch (ex) {
        console.error(ex);
        this.showError = true;
      }

      this.closeWorkersPopup();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.project-provider-table-cell {
  display: block;
  flex-direction: column;
  justify-content: center;

  .add-new-worker-button {
    color: #fff;
    font-size: $font-size-sm;
    font-weight: 500;
    letter-spacing: 1.07px;
    line-height: rem(16);
    text-align: center;
    text-transform: uppercase;
    background-color: var(--brand-primary) !important;
    z-index: 4;
  }
}

.name {
  font-size: $font-size-base;
  line-height: rem(20);
  display: inline-block;
}

img.avatar {
  width: rem(24);
  height: rem(24);
  display: inline-block;
}

::v-deep .v-avatar {
  min-width: rem(24) !important;
  width: rem(24) !important;
  min-height: rem(24) !important;
  height: rem(24) !important;
  margin: $space-2 $space-2 $space-2 0;
}

.initials {
  background-color: rgba(14, 31, 51, 0.15);
  border-radius: rem(50);
  color: var(--text-secondary);
  height: rem(24);
  width: rem(24);
  font-size: $font-size-base;
  font-family: $font-family-regular;
}
</style>
